import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"
import { Carousel } from "antd"

function Banner({ banners = [], children }) {
  const classnames = classModuleGenerator(styles)
  return (
    <div className={classnames("banner-container")}>
      <div className={classnames("banner-list")}>
        <Carousel autoplay={true} dots={false}>
          {banners.map((m) => {
            return (
              <div key={m._id} className={classnames("banner-item-wrap")}>
                <img
                  className={classnames("banner-item")}
                  src={m.imageUrl}
                  alt={m.intro || ""}
                  title={m.name}
                />
                {children}
              </div>
            )
          })}
        </Carousel>
      </div>
    </div>
  )
}

export default Banner
